import type { FindingsResponse } from '../../api/findings';
import './FindingsSummary.css';

interface Props {
  findings: FindingsResponse;
  onOpenAll: () => void;
}

const ROWS: Array<{ key: string; label: string; tone: 'urgent' | 'warn' | 'info' | 'ok' }> = [
  { key: 'URGENT', label: 'Urgent', tone: 'urgent' },
  { key: 'ATTEND', label: 'Attend', tone: 'warn' },
  { key: 'WATCH', label: 'Watch', tone: 'info' },
  { key: 'ROUTINE', label: 'Routine', tone: 'info' },
];

export function FindingsSummary({ findings, onOpenAll }: Props) {
  const total = findings.count;
  const dimensions = Object.entries(findings.by_dimension)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 4);

  return (
    <div className="findings-summary glass">
      <div className="findings-summary__header">
        <div className="label">Findings</div>
        <button
          type="button"
          className="findings-summary__open"
          onClick={onOpenAll}
        >
          Open all →
        </button>
      </div>
      <div
        className={`findings-summary__total${
          total === 0 ? ' findings-summary__total--ok' : ''
        }`}
      >
        {total === 0 ? 'All clear' : `${total} active`}
      </div>
      <ul className="findings-summary__list">
        {ROWS.map((row) => {
          const count = findings.by_severity?.[row.key] ?? 0;
          if (count === 0) return null;
          return (
            <li key={row.key} className="findings-summary__row">
              <span className="findings-summary__label">{row.label}</span>
              <span
                className={`findings-summary__count findings-summary__count--${row.tone}`}
              >
                {count}
              </span>
            </li>
          );
        })}
      </ul>
      {dimensions.length > 0 && (
        <div className="findings-summary__dims">
          {dimensions.map(([dim, n]) => (
            <span key={dim} className="findings-summary__dim">
              {dim} <span className="findings-summary__dim-count">{n}</span>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
